<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-button (click)="goBlastHomePage()">
        <ion-icon color="dark" class="back-icon" name="chevron-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      <app-offline-indicator></app-offline-indicator>
      <ng-container *ngIf="type === 'package'">{{ 'BLAST.package.title' | translate }}</ng-container>
      <ng-container *ngIf="type === 'sent'">
        <ng-container *ngIf="blastUsage.blastType === 'sms'">
          {{ 'BLAST.status.sms_result' | translate }}
        </ng-container>
        <ng-container *ngIf="blastUsage.blastType === 'whatsapp'">
          {{ 'BLAST.status.whatsapp_result' | translate }}
        </ng-container>
      </ng-container>
    </ion-title>
  </ion-toolbar>
  <ion-toolbar class="ion-no-padding" color="primary">
    <div class="content-div ion-padding ion-margin full-width">
      <ion-img class="img center" src="./assets/wedding/img/blast/result/result.webp"></ion-img>
    </div>
  </ion-toolbar>
</ion-header>

<ion-content color="light">
  <div class="content-div ion-padding-top ion-text-left">
    <ng-container *ngIf="type === 'sent'">
      <app-blast-usage-detail [pageMode]="true" [disableWatch]="true" [blastUsage]="blastUsage" [blastMsgList]="blastMsgList" [setReady]="ready"></app-blast-usage-detail>
    </ng-container>
    <ng-container *ngIf="type === 'package'">
      <div class="ion-text-center ion-margin">
        <ion-text [innerHTML]="'PAYMENT.title.success' | translate"></ion-text>
      </div>
      <div class="ion-text-center ion-margin" *ngIf="count">
        <ion-text [innerHTML]="'BLAST.package.total_purchased_count' | translate: { count }"></ion-text>
      </div>
    </ng-container>
  </div>
</ion-content>
<ion-footer>
  <ion-toolbar>
    <div class="content-div ion-padding">
      <ion-button expand="block" (click)="goBlastHomePage()">{{ 'MENU.home' | translate }}</ion-button>
    </div>
  </ion-toolbar>
</ion-footer>
